var React = require('react');

function IconCaretUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 17.0007L12 7.00073L22 17.0007","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconCaretUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconCaretUp;

IconCaretUp.default = IconCaretUp;
